<template>
  <div class="teacher-search">
    <van-nav-bar title="教师详情" left-arrow @click-left="$router.back()" />
    <van-skeleton title :row="3" :loading="loading" style="margin-top: 40px">
      <div class="teacher-detail" v-if="teacher.id">
        <!-- 教师信息卡片 -->
        <div class="custom-card">
          <!-- 教师头像 -->
          <div class="card-header">
            <!-- <img :src="teacher.avatar + '1'" class="avatar" /> -->

            <van-image :src="teacher.avatar" class="avatar" radius="8" />

            <!-- <van-image width="200" height="200" :src="teacher.avatar"  radius="16"/> -->
          </div>

          <!-- 教师信息 -->
          <!-- <div class="card-body">
          <p class="name">{{ teacher.name }}</p>
          <p class="info-item"><strong>电话：</strong>{{ teacher.phone }}</p>
          <p class="info-item"><strong>专业：</strong>{{ teacher.major }}</p>
          <p class="info-item">
            <strong>入园时间：</strong>{{ teacher.admissiontime }}
          </p>
          <p class="info-item">
            <strong>出园时间：</strong>{{ teacher.exittime }}
          </p>
          <p class="info-item">
            <strong>简介：</strong>{{ teacher.introduction }}
          </p>
        </div> -->
          <van-cell-group :border="false">
            <!-- <van-cell :title="teacher.name" title-class="cell-name" icon="user-circle-o" /> -->
            <van-cell :title="teacher.name" title-class="cell-name" />
            <!-- <van-cell
              title="电话"
              :value="teacher.phone"
              title-class="cell-item"
              value-class="cell-item"
            /> -->
            <van-cell
              title="专业"
              :value="teacher.major"
              title-class="cell-item"
              value-class="cell-item"
            />
            <van-cell
              title="入园时间"
              :value="teacher.admissiontime"
              title-class="cell-item"
              value-class="cell-item"
            />
            <van-cell
              title="出园时间"
              :value="teacher.exittime"
              title-class="cell-item"
              value-class="cell-item"
            />
            <van-cell
              v-if="teacher?.introduction"
              title="简介"
              title-class="cell-item"
              label-class="cell-label"
            >
              <template #label>
                <div v-html="introduction"></div>
              </template>
            </van-cell>
            <van-cell
              v-if="teacher?.cert"
              title="证书"
              title-class="cell-item"
              label-class="cell-label"
            />
          </van-cell-group>
          <div
            v-if="teacher?.cert"
            class="teacher-container"
            @click="showImage = true"
          >
            <img :src="certificateSrc" class="teacher-bg" />
          </div>
        </div>

        <van-image-preview
          v-if="teacher"
          :images="[certificateSrc]"
          :show-index="false"
          v-model="showImage"
          closeable
        ></van-image-preview>
      </div>

      <van-empty v-if="!teacher.id" description="暂无教师详情" />
    </van-skeleton>
  </div>
</template>

<script>
import api from "@/api";
import { getStorage } from "@/utils/config";

export default {
  name: "TeacherDetail",
  computed: {
    // 获取证书图片绝对路径
    certificateSrc() {
      return this.teacher?.cert
        ? this.teacher?.cert.startsWith("http")
          ? this.teacher?.cert
          : getStorage() + this.teacher?.cert
        : "";
    },
    introduction() {
      // 处理教师简介中的换行符
      return this.teacher.introduction
        ? this.teacher.introduction.split("\n").join("<br/>")
        : "";
    },
  },
  data() {
    return {
      teacher: {},
      showImage: false, // 控制图片预览
      loading: true, // 控制加载状态
    };
  },
  methods: {
    async fetchTeacherDetail() {
      const { id } = this.$route.params;
      try {
        console.log("id", id);
        const res = await api.getTeacherDetail({ id });
        console.log("res", res);
        if (res.data.data && res.data.success) {
          this.teacher = res.data.data;
          console.log("data", res.data.data);
          // const introduction = this.teacher.introduction || "";
          // console.log("introduction", JSON.stringify(introduction));
          // console.log(
          //   "teacher",
          //   introduction.includes("\n"),
          //   introduction.split("\n")
          // );
        } else {
          this.$toast.fail("未找到相关教师信息");
        }
      } catch (err) {
        this.$toast.fail("加载教师信息失败");
      } finally {
        this.loading = false; // 设置加载状态为false
      }
    },
  },
  mounted() {
    this.fetchTeacherDetail();
  },
};
</script>

<style scoped>
.teacher-search {
  padding: 20px;
  margin-bottom: 20px;
}
.teacher-detail {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  /* text-align: center; */
}

/* 自定义卡片布局 */
.custom-card {
  background: #fff;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 480px;
  margin-top: 20px;
}

/* 卡片头部：头像 */
.card-header {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.avatar {
  width: 146px;
  height: 220px;
  border-radius: 12px;
  object-fit: cover;
}

/* 卡片主体：教师信息 */
.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.info-item {
  font-size: 16px;
  margin-bottom: 8px;
  color: #666;
}

.cell-name {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #333;
  margin: 10px 0;
}

.cell-item {
  font-size: 16px;
  color: #666;
}
.cell-label {
  font-size: 14px;
  color: #999;
  padding: 6px 0;
  line-height: 20px;
}

.teacher-container {
  position: relative;
  /* width: 800px; */
  /* height: 550px; */
  margin: 0 auto;
  text-align: center;
  margin-top: 4px;
  padding: 0 16px;
}

.teacher-bg {
  width: 100%;
  height: auto;
}
</style>
